import { render, staticRenderFns } from "./BanerCarousel.vue?vue&type=template&id=736af319&scoped=true&"
import script from "./BanerCarousel.vue?vue&type=script&lang=js&"
export * from "./BanerCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BanerCarousel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BanerCarousel.vue?vue&type=style&index=1&id=736af319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736af319",
  null
  
)

export default component.exports